import { useMemo, useCallback } from "react";

import useActivationQueryWithAccessControl from "app/custom-hooks/activation/useActivationQueryWithAccessControl";
import type { IUserKeywordGroup } from "app/services/keyword-groups";
import { useAllKeywordGroups, useUpdateKeywordGroup } from "app/services/keyword-groups/hooks";
import { SegmentsPageLoader } from "app/pages/segments/segmentsPageLoader";

import { MonitorKeywordsPage } from "./MonitorKeywordsPage";

export const MonitorKeywordsPageContainer = () => {
    const {
        data: activationSets,
        isPlaceholderData: isActivationSetPlaceholderData,
        isError: isActivationSetError,
        isLoading: isActivationSetLoading,
    } = useActivationQueryWithAccessControl();

    const { userGroups, sharedGroups, isLoading: isGroupLoading } = useAllKeywordGroups();
    const { mutateAsync: updateKeywordGroupAsync } = useUpdateKeywordGroup();

    const keywordGroupsData = useMemo(
        () => ({
            OwnerGroups: userGroups,
            SharedGroups: sharedGroups,
        }),
        [userGroups, sharedGroups],
    );

    const updateKeywordGroupCompatibility = useCallback(
        async (group: IUserKeywordGroup) => {
            const updatedGroup = await updateKeywordGroupAsync(group);
            return userGroups.map((g) => (g.Id === updatedGroup.Id ? updatedGroup : g));
        },
        [updateKeywordGroupAsync, userGroups],
    );

    const props = {
        activationSets,
        isActivationSetError,
        isActivationSetPlaceholderData,
        keywordGroupsData,
        updateKeywordGroup: updateKeywordGroupCompatibility,
    };

    if (isActivationSetLoading || isGroupLoading) {
        return <SegmentsPageLoader />;
    }
    return <MonitorKeywordsPage {...props} />;
};
